import { OnInit, Renderer2, ElementRef, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { TournamentService } from 'src/app/tournamentpopup/tournament.service';
import { FormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MainService } from 'src/app/_services/main.service';
import { Store } from '@ngrx/store';
import { MiniLobbyData, TournamentMiniLobbyData, UserBalanceData } from 'src/app/store/actions/appActions';
import { DeviceDetectorService } from 'ngx-device-detector';
import { InviteFriendsComponent } from '../components/invite-friends/invite-friends.component';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { NgxSpinnerService } from 'ngx-spinner';
var LeagueRegPopupComponent = /** @class */ (function () {
    function LeagueRegPopupComponent(popupData, _appService, dialog, leagueDialogRef, tournamentService, formBuilder, router, store, deviceService, renderer, elementRef, inviteFriendsDialogRef, spinner) {
        var _this = this;
        this.popupData = popupData;
        this._appService = _appService;
        this.dialog = dialog;
        this.leagueDialogRef = leagueDialogRef;
        this.tournamentService = tournamentService;
        this.formBuilder = formBuilder;
        this.router = router;
        this.store = store;
        this.deviceService = deviceService;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.inviteFriendsDialogRef = inviteFriendsDialogRef;
        this.spinner = spinner;
        this.submitted = false;
        this.show_phone = false;
        this.user_id = 0;
        this.isMobile = false;
        this.countNumber = 0;
        this.selectCounter = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        this.drafttype_id = 1;
        this.tournament_code = '';
        this.second_per_pick = 0;
        this.use_ticket = 0;
        this.is_campaign = "0";
        this.darkMode = false;
        this.darkMode_ext = '';
        this.phpUrl = "" + environment.phpUrl;
        this.isMobile = this.deviceService.isMobile();
        this.parameters = popupData;
        this.result = this.parameters.result;
        this.result.league_id = this.parameters.league_id;
        if (this.result.max_multijoin != null) {
            var multijoinArray = Array.from(Array(this.result.max_multijoin + 1).keys());
            this.selectCounter = multijoinArray.slice(1, multijoinArray.length);
        }
        this.selectCounter = this.validateMaxEntries();
        if (this.parameters.drafttype_id != null)
            this.drafttype_id = this.parameters.drafttype_id;
        if (this.parameters.tournament_code)
            this.tournament_code = this.parameters.tournament_code;
        if (this.result.draft_speed_set)
            this.second_per_pick = this.result.draft_speed_set[0]['value'];
        if (this.result.ticket)
            this.use_ticket = this.result.ticket.checked;
        this.store.select('DarkModeReducer').subscribe(function (state) {
            if (state.length > 0) {
                _this.darkMode = state[0].isDarkMode;
                _this.darkMode_ext = _this.darkMode ? '_icon-dark' : '';
            }
        });
    }
    LeagueRegPopupComponent.prototype.ngOnInit = function () {
        this.assetURL = "" + environment.assetURL;
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (this.currentUser != null) {
            this.user_id = this.currentUser.id;
            this.countNumber = 0;
        }
        this.joinForm = this.formBuilder.group({
            msg_send: [false, ''],
            league_code: [this.parameters.league_code, ''],
            draft_type: [this.parameters.draft_type, ''],
            user_id: [this.user_id, ''],
            phone_number: ['', [Validators.minLength(10), Validators.maxLength(12)]],
            /*multi_entry: [false],*/
            counter: ['1'],
            assigned_rank: ['0', ''],
            ip: [''],
            second_per_pick: this.second_per_pick,
            ticket_id: 0,
            use_ticket: this.use_ticket
        });
        this.getJoinData();
        this.getIpAddress();
        /**Load Jquery for hubzity event tracking */
        if (!this.checkJqueyLoaded() && this.is_campaign == "1") {
            var script = this.renderer.createElement('script');
            script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js';
            script.onload = function () {
                console.log('script loaded');
            };
            document.getElementsByTagName("head")[0].appendChild(script);
            // document.getElementsByTagName( "head" )[0].appendChild( script );
        }
    };
    Object.defineProperty(LeagueRegPopupComponent.prototype, "f", {
        // convenience getter for easy access to form fields
        get: function () { return this.joinForm.controls; },
        enumerable: true,
        configurable: true
    });
    LeagueRegPopupComponent.prototype.smsToggle = function () {
        this.show_phone = !this.show_phone;
        var phone_number = this.joinForm.get('phone_number');
        this.joinForm.get('msg_send').valueChanges
            .subscribe(function (status) {
            if (status) {
                phone_number.setValidators([Validators.required, Validators.minLength(12), Validators.maxLength(12)]);
            }
            else {
                phone_number.setValidators(null);
            }
            phone_number.updateValueAndValidity();
        });
        /* if (this.show_phone) {
          phone_number.setValidators([Validators.minLength(12),Validators.maxLength(12)]);
        }else{
          phone_number.setValidators(null);
        }
        
        phone_number.updateValueAndValidity(); */
    };
    LeagueRegPopupComponent.prototype.counterChange = function () {
        // Calculate total entry fees when user change the number of drafts
        if (this.joinForm.get('counter').value > 0) {
            this.result.entry_fee = this.result.currency + this.roundNumber(this.result.league_fee * this.joinForm.get('counter').value, 1);
            if (this.joinForm.get('counter').value > 1)
                this.result.entry_fee += " (" + this.result.currency + this.roundNumber(this.result.league_fee, 1) + " x " + this.joinForm.get('counter').value + ")";
        }
        return true;
    };
    LeagueRegPopupComponent.prototype.validateMaxEntries = function () {
        // Validate max number of possible entries user can make to join particular draft
        var maxPossibleJoin = this.roundNumber(this.result.balance / this.result.league_fee, 0);
        return this.selectCounter.slice(0, maxPossibleJoin);
    };
    LeagueRegPopupComponent.prototype.ticketToggle = function () {
        var _this = this;
        this.joinForm.get('use_ticket').valueChanges
            .subscribe(function (status) {
            if (status) {
                _this.use_ticket = 1;
                _this.joinForm.controls['ticket_id'].setValue(_this.result.ticket.ticket_id);
            }
            else {
                _this.use_ticket = 0;
                _this.joinForm.controls['ticket_id'].setValue(0);
            }
        });
    };
    LeagueRegPopupComponent.prototype.keyPress = function (event) {
        var pattern = /[0-9\+\-\ ]/;
        var phonel = this.f.phone_number.value;
        var inputChar = String.fromCharCode(event.charCode);
        if ((event.keyCode !== 8 && !pattern.test(inputChar)) || phonel.length > 11) {
            event.preventDefault();
        }
        else {
            var countNumber = (this.f.phone_number.value) ? phonel.length : 0;
            if (countNumber === 3 || countNumber === 7) {
                var phone_number = this.f.phone_number.value + '-';
                this.joinForm.controls['phone_number'].setValue(phone_number);
            }
        }
    };
    LeagueRegPopupComponent.prototype.getJoinData = function () {
        var _this = this;
        if (this.result) {
            if (this.result.ranking_set) {
                var is_default_1 = false;
                this.result.ranking_set.forEach(function (element) {
                    if (element.is_default === 1) {
                        is_default_1 = true;
                        _this.joinForm.controls['assigned_rank'].setValue(element.value.toString());
                    }
                });
                if (!is_default_1) {
                    this.joinForm.controls['assigned_rank'].setValue('0');
                }
            }
            if (this.result.draft_speed_set && this.result.draft_speed_set.length > 1) {
                var active_1 = false;
                this.result.draft_speed_set.forEach(function (element) {
                    if (element.active === 1) {
                        active_1 = true;
                        _this.joinForm.controls['second_per_pick'].setValue(element.value.toString());
                    }
                });
                if (!active_1) {
                    this.joinForm.controls['second_per_pick'].setValue(0);
                }
            }
            else {
                this.joinForm.controls['second_per_pick'].setValue(this.second_per_pick);
            }
            if (this.result.show_phone) {
                this.show_phone = this.result.show_phone;
                this.joinForm.controls['msg_send'].setValue(true);
            }
            else {
                this.show_phone = this.result.show_phone;
                this.joinForm.controls['msg_send'].setValue(false);
                //this.joinForm.controls['phone_number'].setValue('');
            }
            this.joinForm.controls['phone_number'].setValue(this.result.phone_number);
            if (this.use_ticket) {
                this.joinForm.controls['ticket_id'].setValue(this.result.ticket.ticket_id);
            }
        }
        /* if (this.parameters.league_code) {
          this.sub_result = this.tournamentService.getJoinPopUpData(this.parameters.league_code, this.user_id).subscribe(res => {
            if (typeof res !== 'undefined' && res.status === 'success') {
              this.result = res.entities;
              if (this.result.ranking_set) {
                this.result.ranking_set.forEach(element => {
                  if (element.is_default === 1) {
                    this.joinForm.controls['assigned_rank'].setValue(element.value);
                  }
                });
              }
            }
          });
        } */
    };
    LeagueRegPopupComponent.prototype.getIpAddress = function () {
        var _this = this;
        this.tournamentService.getIpAddress(this.user_id).subscribe(function (data) {
            _this.joinForm.get('ip').setValue(data.ip);
        });
    };
    LeagueRegPopupComponent.prototype.onSubmit = function () {
        var _this = this;
        this.submitted = true;
        // stop here if form is invalid
        if (this.joinForm.invalid) {
            return;
        }
        else {
            this.spinner.show();
            this.sub_joinLeague = this.tournamentService.joinLeague(this.joinForm.value).pipe(first()).subscribe(function (data) {
                _this.submitted = false;
                _this.spinner.hide();
                if (data.status === 'success') {
                    /**Update user balance */
                    if (_this.joinForm.value.ticket_id == 0) {
                        _this.result.balance = parseFloat(_this.result.balance) - parseFloat(_this.result.league_fee);
                        _this.store.dispatch(new UserBalanceData(_this.result.balance));
                    }
                    if (_this.f['counter'].value && _this.f['counter'].value > 1) {
                        _this.parameters.league_id = data.fantasy_lg_id;
                        _this.parameters.league_code = data.league_code;
                        _this.joinMultiEntry();
                    }
                    _this.hideModalBox((_this.drafttype_id < 4) ? null : data);
                    if (_this.drafttype_id < 4) {
                        setTimeout(function () {
                            if (data.is_full === true) {
                                //this.router.navigate(['/draft/' + this.result.league_id]);
                            }
                            else {
                                var rannkUrl = "" + environment.SITE_URL + '/draft/ranking/' + _this.result.league_type + '/' + data.league_code;
                                if (_this.tournament_code != '') {
                                    var inviteUrl = "" + environment.SITE_URL + '/tournament/' + _this.result.league_type + '/' + _this.tournament_code + '?invite=yes';
                                }
                                else {
                                    var inviteUrl = "" + environment.SITE_URL + '/league/profile/' + _this.result.league_type + '/' + data.league_code + '?invite=yes';
                                }
                                var body = data.message;
                                _this.inviteFriendsDialogRef = _this.dialog.open(InviteFriendsComponent, {
                                    width: '460px',
                                    data: { 'body': body, 'invite_url': inviteUrl, 'ranking_url': rannkUrl, 'fantasy_lg_id': data.fantasy_lg_id, 'rem_entratns': data.rem_entratns, 'entrants': data.entrants }
                                });
                                /* const rannkUrl = `${environment.SITE_URL}`+'/draft/ranking/'+this.result.league_type+'/'+data.league_code;
                  
                                window.location.href = rannkUrl; */
                            }
                        }, 500);
                    }
                    //this.refreshJoinDraftMiniLobby();
                    if (_this.is_campaign == "1")
                        _this.trackHubZityEvents("6");
                }
                else if (data.status == 'failure') {
                    _this.leagueDialogRef.close((_this.drafttype_id < 4) ? 0 : data);
                    _this.confirmDialogRef = _this.dialog.open(ConfirmboxComponent, {
                        width: '500px',
                        data: { 'title': "Warning", 'body': data.message, 'type': 'alert-box' }
                    });
                    _this.confirmDialogRef.afterClosed()
                        .subscribe(function (res) {
                        if (res) { }
                    });
                }
                else {
                    _this.leagueDialogRef.close((_this.drafttype_id < 4) ? 0 : data);
                }
            }, function (error) {
                _this.submitted = false;
                _this.leagueDialogRef.close(0);
                console.log(error);
            });
        }
    };
    // submit multi entry
    LeagueRegPopupComponent.prototype.joinMultiEntry = function () {
        var formData = { league_id: this.parameters.league_id, league_code: this.parameters.league_code, common_rank_id: this.f['assigned_rank'].value, user_id: this.user_id, ip: '', msg_send: this.f['msg_send'].value, phone_number: this.f['phone_number'].value, counter: this.f['counter'].value - 1, tournament_id: (this.parameters.result.tournament_id != null) ? this.parameters.result.tournament_id : 0, second_per_pick: this.f['second_per_pick'].value };
        //Counter reduced by 1 as 1 entry has already done on first join
        this.sub_joinLeague = this.tournamentService.joinMultiEntry(formData).pipe(first()).subscribe(function (data) {
        });
    };
    LeagueRegPopupComponent.prototype.refreshJoinDraftMiniLobby = function () {
        var _this = this;
        if (this.parameters.draft_type === 'league') {
            this._appService.getActiveLeague(this.user_id, 0)
                .subscribe(function (res) {
                _this.store.dispatch(new MiniLobbyData(res.result));
            }, function (err) {
                console.log(err);
            });
        }
        else if (this.parameters.draft_type === 'tournament') {
            this._appService.getActiveDraft(this.user_id, 'all')
                .subscribe(function (res) {
                if (res.result) {
                    _this.store.dispatch(new TournamentMiniLobbyData(res.result));
                }
            }, function (err) {
                console.log(err);
            });
        }
    };
    LeagueRegPopupComponent.prototype.hideModalBox = function (data) {
        if (data === void 0) { data = null; }
        this.leagueDialogRef.close((data == null) ? 1 : data);
        //this.dialog.closeAll();
    };
    LeagueRegPopupComponent.prototype.roundNumber = function (number, decimalPlace) {
        var decimal = Math.pow(10, decimalPlace);
        return Math.floor(number * decimal) / decimal;
    };
    LeagueRegPopupComponent.prototype.trackHubZityEvents = function (TRACKING_CONVERSION_STAGE) {
        /* Hubzity conversion stage tracking start */
        if (window.trackingStoreSession !== undefined && window.trackingConversion !== undefined) {
            window.trackingStoreSession();
            window.trackingConversion(TRACKING_CONVERSION_STAGE);
        }
        else {
            var head = document.getElementsByTagName("head")[0];
            var trackingScript = document.createElement("script");
            trackingScript.setAttribute("async", 'true');
            trackingScript.setAttribute("src", "//static.rtbaxs.io/tracking.min.js?ts=" + new Date().getTime());
            trackingScript.addEventListener("load", function () {
                window.trackingStoreSession();
                window.trackingConversion(TRACKING_CONVERSION_STAGE); //use this in each following pages in case you want to track their loading
            });
            trackingScript.addEventListener("error", function () {
                console.log("Failed to load Hubzity tracking SDK");
            });
            head.appendChild(trackingScript);
        }
        /* Hubzity conversion stage tracking end */
    };
    LeagueRegPopupComponent.prototype.checkJqueyLoaded = function () {
        var isFound = false;
        var scripts = document.getElementsByTagName("script");
        for (var i = 0; i < scripts.length; ++i) {
            if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("jquery.min.js")) {
                isFound = true;
            }
        }
        //console.log("jquery loaded:",isFound);
        return isFound;
    };
    LeagueRegPopupComponent.prototype.ngOnDestroy = function () {
        // this.sub_joinLeague.unsubscribe();
        // this.sub_result.unsubscribe();
    };
    LeagueRegPopupComponent.prototype.openAppPopup = function (tlgid) {
        this.confirmDialogRef = this.dialog.open(this.mobileApp, {
            width: this.isMobile ? '90%' : '50%',
            data: {}
        });
        this.confirmDialogRef.afterClosed()
            .subscribe(function (res) { });
    };
    return LeagueRegPopupComponent;
}());
export { LeagueRegPopupComponent };
